import { Contact } from "@/types/contacts";
import { ContactStatsCards } from "./ContactStatsCards";
import { ContactFilterPanel } from "./ContactFilterPanel";
import { ContactTable } from "./ContactTable";

interface ContactDashboardProps {
  contacts: Contact[];
  allContacts: Contact[];
  selectedRegion: string;
  selectedState: string;
  selectedType: string;
  selectedCompany: string;
  searchName: string;
  onRegionChange: (region: string) => void;
  onStateChange: (state: string) => void;
  onTypeChange: (type: string) => void;
  onCompanyChange: (company: string) => void;
  onSearchNameChange: (name: string) => void;
  onUpdateContact?: (contact: Contact) => void;
  onDeleteContact?: (contact: Contact) => Promise<void>;
}

export function ContactDashboard({
  contacts,
  allContacts,
  selectedRegion,
  selectedState,
  selectedType,
  selectedCompany,
  searchName,
  onRegionChange,
  onStateChange,
  onTypeChange,
  onCompanyChange,
  onSearchNameChange,
  onUpdateContact,
  onDeleteContact,
}: ContactDashboardProps) {
  return (
    <div className="space-y-8" data-contact-table>
      <ContactStatsCards contacts={contacts} />

      <ContactFilterPanel
        contacts={allContacts}
        selectedRegion={selectedRegion}
        selectedState={selectedState}
        selectedType={selectedType}
        selectedCompany={selectedCompany}
        searchName={searchName}
        onRegionChange={onRegionChange}
        onStateChange={onStateChange}
        onTypeChange={onTypeChange}
        onCompanyChange={onCompanyChange}
        onSearchNameChange={onSearchNameChange}
      />

      <ContactTable 
        contacts={contacts}
        onUpdateContact={onUpdateContact}
        onDeleteContact={onDeleteContact}
      />
    </div>
  );
}
